var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { markRaw, createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      d: "M8.66667 2C9.03486 2 9.33333 2.29848 9.33333 2.66667C9.33333 3.03486 9.03486 3.33333 8.66667 3.33333H3.33333V4.15104L3.34505 4.27344C3.36757 4.39409 3.42297 4.50689 3.50651 4.59896L6.49349 7.88542C6.60483 8.00808 6.66667 8.16766 6.66667 8.33333V13.0742L9.33333 12.1849V8C9.33333 7.82319 9.40362 7.65367 9.52865 7.52865L10.862 6.19531C11.1223 5.93496 11.5443 5.93496 11.8047 6.19531C12.065 6.45566 12.065 6.87767 11.8047 7.13802L10.6667 8.27604V12.6667C10.6667 12.9536 10.4832 13.2087 10.2109 13.2995L6.21094 14.6328C6.00768 14.7006 5.78451 14.6656 5.61068 14.5404C5.43683 14.4151 5.33333 14.2143 5.33333 14V8.58984L2.51953 5.49609C2.2271 5.17419 2.04926 4.76696 2.00911 4.33724L2 4.15104V2.66667C2 2.29848 2.29848 2 2.66667 2H8.66667Z",
      fill: "currentColor",
      "fill-opacity": "0.6824"
    }, null, -1),
    createElementVNode("path", {
      d: "M14 0C15.1046 0 16 0.895431 16 2C16 3.10457 15.1046 4 14 4C12.8954 4 12 3.10457 12 2C12 0.895431 12.8954 0 14 0Z",
      fill: "currentColor",
      "fill-opacity": "0.6824"
    }, null, -1)
  ]));
}
__name(render, "render");
const filterDot = markRaw({ name: "custom-filter-dot", render });
export {
  filterDot as default
};
//# sourceMappingURL=filter-dot.js.map
